import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Input, Modal, ModalBody, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import MediaUploader from "Components/Common/MediaUploader";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkMediaUrlThunk, createMediaCenter, createMediaCenterUrl, getmedia } from "live-slices/thunk";
import { checkMediaUrl } from "helpers/backend_helper";
import { aU } from "@fullcalendar/core/internal-common";


const UploadImageModal = ({ show, onDeleteClick, onCloseClick, selectedFolderId }: any) => {

  const [activeArrowTab, setactiveArrowTab] = useState(4);
  const [passedarrowSteps, setPassedarrowSteps] = useState([4]);
  const [media, setMedia] = useState<any>(null);
  const [mediaData, setMediaData] = useState<any>(null);
  const dispatch = useDispatch<any>();
  const [imageUrl, setImageUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);





  function toggleArrowTab(tab: any) {
    if (activeArrowTab !== tab) {
      var modifiedSteps = [...passedarrowSteps, tab];

      if (tab >= 4 && tab <= 8) {
        setactiveArrowTab(tab);
        setPassedarrowSteps(modifiedSteps);
      }
    }
  }

  const handleMediaUpdate = (value: any) => {
    setMediaData(value);
  };

  const mediaFunc = async () => {
    try {
      const updatedMediaData = mediaData.map((mediaItem: any) => ({
        ...mediaItem,
        folderId: selectedFolderId,
      }));

      await dispatch(createMediaCenter(updatedMediaData)).then(()=>{
        setTimeout(() => {
          dispatch(getmedia({ folderid:selectedFolderId,keyword: "", stardate: 0, enddate: 0 }));
          // dispatch(getMediaByFolderID(selectedFolderId));
        }, 1000);
        onCloseClick(true);
      })
    } catch (error) {
      console.error("Upload failed with error:", error);
      onCloseClick(true);
    }
  };



  const mediaUrl = async () => {
    const media = [
      {
        id: '',
        isExternal: true,
        url: imageUrl,
        metaData: {
          height: 0,
          width: 0,
          fileType: 'image',
          fileFormat: 'jpg',
          name: '',
          duration: 0,
        },
        folderId: selectedFolderId,
      },
    ];
   await dispatch(createMediaCenterUrl(media));
    setTimeout(() => {
       dispatch(getmedia({ folderid:selectedFolderId,keyword: "", stardate: 0, enddate: 0 }));
      //  dispatch(getMediaByFolderID(selectedFolderId));
    }, 1000);
    setImageUrl("");
    setValidationMessage("");
    setactiveArrowTab(4)
    onCloseClick(true);
 
  };


  const [loading, setLoading] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [error, setError] = useState('');

  const validateMedia = async (url: string) => {
    try {
      setLoading(true);
      setValidationMessage('');
      setError('');
      const response = await checkMediaUrl({ url });
      if (response.data === true) {
        setValidationMessage('Media Verified Successfully');
      } else {
        setValidationMessage('Media Not Valid');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error validating media');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (imageUrl) {
        validateMedia(imageUrl);
      }
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [imageUrl]);

  const handleConfirm = async () => {
    if (activeArrowTab === 4 && !mediaData?.length) {
      toast.error("Please upload at least one image before confirming!", { autoClose: 1000 });
      return;
    }

    if (activeArrowTab === 5 && !imageUrl.trim()) {
      toast.error("Please enter a valid image URL before confirming!", { autoClose: 1000 });
      return;
    }

    setIsLoading(true);
    try {
      if (activeArrowTab === 4) {
        await mediaFunc();
      } else if (activeArrowTab === 5) {
        await mediaUrl();
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      setImageUrl('');
      setValidationMessage('');
      setactiveArrowTab(4); 
      setMediaData(null);
    }
  }, [show]);
  

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} className="imageUpladmodal position-relative" backdrop="static">
      <ModalBody className="py-3 px-5" >
        <div className="text-end">
          <i className='bx bx-x fs-2 cursor-pointer' data-testing-Id="closeIcon_uploadimage" style={{ color: "#CACACA" }} onClick={onCloseClick}></i>
        </div>
        <Row className="border-bottom mb-3">
          <Col md={4} sm={12} className="p-0">
            <div className="step-arrow-nav ">
              <Nav className="nav-pills custom-nav nav-justified" role="tablist">
                <NavItem style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  <NavLink
                    href="#"
                    id="steparrow-gen-info-tab"
                    data-testing-Id="uploadImageTab_mediaCenter"
                    className={classnames({
                      active: activeArrowTab === 4,
                      done: activeArrowTab <= 6 && activeArrowTab > 3,
                    })}
                    onClick={() => {
                      toggleArrowTab(4);
                    }}
                    style={{
                      whiteSpace: "nowrap", // Prevents text from breaking into new lines
                      overflow: "hidden",   // Hides overflow text
                      textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px", // Adds some padding for spacing
                    }}
                  >
                    Upload Image
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  <NavLink
                    href="#"
                    id="steparrow-gen-info-tab"
                    data-testing-Id="urlImageTab_uploadimage"
                    className={classnames({
                      active: activeArrowTab === 5,
                      done: activeArrowTab <= 6 && activeArrowTab > 4,
                    })}
                    onClick={() => {
                      toggleArrowTab(5);
                    }}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px",
                    }}
                  >
                    URl Image
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </Col>
        </Row>
        <TabContent activeTab={activeArrowTab}>
          <TabPane id="steparrow-gen-info" tabId={4}>

            <MediaUploader
              onMediaUpdate={handleMediaUpdate}
              isMultiple={true}
              initialMedia={mediaData}
              dataTestingId={"buyerImageTow_addProduct"}
            />
          </TabPane>

          <TabPane id="steparrow-description-info" tabId={5}>
            <div>
              <Input
                type="text"
                data-testing-id="imageUrlInput_uploadimage"
                placeholder="Enter image URL"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
              />
              {loading && <p>Validating...</p>}
              {validationMessage && <p style={{ color: validationMessage.includes('Not Valid') ? 'red' : 'green' }}>{validationMessage}</p>}
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>
          </TabPane>
        </TabContent>
      </ModalBody>
      <div
        className="d-flex justify-content-end align-items-center position-sticky w-100 bottom-0 bg-white p-3"
        style={{ boxShadow: "0px 0px 11px -4px #CACACA" }}
      >
        <button
          type="button"
          className={`btn btn-secondary me-3 ${isLoading ||
              (activeArrowTab === 4 && !mediaData?.length) ||
              (activeArrowTab === 5 && (!imageUrl.trim() || validationMessage !== "Media Verified Successfully"))
              ? "disabled"
              : ""
            }`}
          data-testing-id="confirmButton_uploadimage"
          onClick={handleConfirm}
          disabled={
            isLoading ||
            (activeArrowTab === 4 && !mediaData?.length) ||
            (activeArrowTab === 5 && (!imageUrl.trim() || validationMessage !== "Media Verified Successfully"))
          }
        >
          {isLoading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Confirm"
          )}
        </button>
        <button
          className="btn btn-outline-dark lightGrayButton"
          type="submit"
          onClick={onCloseClick}
          data-testing-id="cancelButtonUpload_uplaodimage"
          disabled={isLoading}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

UploadImageModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  selectedFolderId: PropTypes.string.isRequired,
};

export default UploadImageModal;